import { useState, useEffect } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Box, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ShareIcon from '@mui/icons-material/IosShare';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import "../styles/banner.scss";

const Banner = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [browser, setBrowser] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const checkBrowser = () => {
        const ua = navigator.userAgent.toLowerCase();
        const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
        const isChrome = ua.includes('chrome') || ua.includes('crios');
        return isSafari || isChrome;
    };

    useEffect(() => {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || window.navigator.standalone === true;

        if (isStandalone) return;

        const ua = navigator.userAgent.toLowerCase();
        const isIOS = /ipad|iphone|ipod/.test(ua) && !window.MSStream;

        if (!checkBrowser()) {
            setIsVisible(true);
            setBrowser('other');
            return;
        }

        if (isIOS) {
            setBrowser('safari');
            setIsVisible(true);
        }

        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setBrowser('chrome');
            setIsVisible(true);
        };

        window.addEventListener('beforeinstallprompt', handler);
        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    const handleInstallClick = async () => {
        if (browser === 'other' || browser === 'safari') {
            setOpenModal(true);
            return;
        }

        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                setDeferredPrompt(null);
                setIsVisible(false);
            }
        }
    };

    if (!isVisible) return null;

    return (
        <>
            <div className="banner__installContainer">
                <p className="banner__installText">Установите наше приложение для быстрого доступа!</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Button className="banner__installButton" onClick={handleInstallClick}>Установить</Button>
                    <IconButton size="small" onClick={() => setIsVisible(false)} sx={{ color: 'inherit', p: 0.5 }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>
            </div>

            <Dialog
                open={openModal}
                onClose={() => setOpenModal(false)}
                maxWidth="xs"
                slotProps={{ paper: { sx: { borderRadius: 3, p: 1 } } }}
            >
                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', pr: 6 }}>
                    {browser === 'other' ? 'Невозможно установить приложение' : 'Установка на iPhone'}
                    <IconButton onClick={() => setOpenModal(false)} sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        {browser === 'other' ? (
                            <>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Box sx={{ bgcolor: '#fff3e0', p: 1, borderRadius: 2, display: 'flex' }}>
                                        <ErrorOutlineIcon sx={{ color: '#ff9800' }} />
                                    </Box>
                                    <Typography>
                                        Текущий браузер не поддерживает установку приложения. Для установки перейдите в <b>Chrome</b> или <b>Safari</b>.
                                    </Typography>
                                </Box>
                            </>
                        ) : (
                            <>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Box sx={{ bgcolor: '#f0f0f0', p: 1, borderRadius: 2, display: 'flex' }}>
                                        <ShareIcon color="primary" />
                                    </Box>
                                    <Typography>
                                        1. Нажмите на кнопку <b>«Поделиться»</b> в браузере Safari.
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Box sx={{ bgcolor: '#f0f0f0', p: 1, borderRadius: 2, display: 'flex' }}>
                                        <AddBoxIcon color="primary" />
                                    </Box>
                                    <Typography>
                                        2. Выберите пункт <b>«На экран "Домой"»</b>.
                                    </Typography>
                                </Box>
                            </>
                        )}
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default Banner;